export default api => ({
    list: params => api.get(`/entities`, params),
    schema: ({ entityKey, params }) => api.get(`/entities/${entityKey}/schema`, params),
    order: ({ entityKey, params }) => api.put(`/entities/${entityKey}/schema/fields`, params),

    createGroup: ({ entityKey, params }) => api.post(`/entities/${entityKey}/schema/groups`, params),
    editGroup: ({ entityKey, groupKey, params }) => api.patch(`/entities/${entityKey}/schema/groups/${groupKey}`, params),
    deleteGroup: ({ entityKey, groupKey, changeGroupBy }) => api.delete(`/entities/${entityKey}/schema/groups/${groupKey}/${changeGroupBy}`),

    transforms: () => api.get('/entities/transforms'),
    styles: () => api.get('/entities/styles'),
    validators: () => api.get('/entities/validators'),

    create: (entityKey, params) => api.post(`/entities/${entityKey}/schema/fields`, params),
    update: (entityKey, params, fieldKey) => api.put(`/entities/${entityKey}/schema/fields/${fieldKey}`, params),
    delete: (entityKey, fieldKey) => api.delete(`/entities/${entityKey}/schema/fields/${fieldKey}`),

    merge: (entityKey, params) => api.post(`/entities/${entityKey}/schema/merge`, params),
    search: (url, params) => api.get(url, params),

    matchRuleCreate: ({ entityKey, params }) => api.post(`/entities/${entityKey}/schema/match-rules`, params),
    matchRuleUpdate: ({ entityKey, ruleKey, params }) => api.put(`/entities/${entityKey}/schema/match-rules/${ruleKey}`, params),
    matchRuleDelete: ({ entityKey, ruleKey }) => api.delete(`/entities/${entityKey}/schema/match-rules/${ruleKey}`),

    compileExpression: (entityKey, params) => api.post(`/entities/${entityKey}/schema/compile-expression`, params),

    setPopupProperties: ({ entityKey, params }) => api.put(`/entities/${entityKey}/schema/popup-properties`, params),
})
